/**
 * @fileoverview AR-805 — single switch point between Classroom adapters and
 * the declaration of which integration surfaces have real backend behind them.
 *
 * Runtime uses the HTTP adapter (phases 1–2 are merged into mosaic-backend
 * main: PR #1384 connection, PR #1386 course/roster). The mock adapter is kept
 * for Jest and for developing without a backend.
 */

import { ClassroomAdapters, ClassroomCapabilities } from './ports'
import { httpClassroomAdapters } from './adapters/httpAdapter'
import { mockClassroomAdapters } from './adapters/mockAdapter'

/** Dev-only override: run the screens against the in-memory mock. */
const CLASSROOM_MOCK_KEY = 'classroom-use-mock'

function devFlag(key: string): boolean {
  try {
    return window.localStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

export function getClassroomAdapters(): ClassroomAdapters {
  return devFlag(CLASSROOM_MOCK_KEY) ? mockClassroomAdapters : httpClassroomAdapters
}

/**
 * What the deployed backend actually supports today.
 *
 * - `managerCourseLinks`: the manager table lists the school's project↔course
 *   links via `GET /google_classroom_courses` (mosaic-backend f3aa900c).
 * - `assignments` / `studentSync`: phase 3 (PR #1387) is merged into main —
 *   assignment creation from tasks and submission import are live.
 * - `gradePush`: phase 4 has no backend and is out of this delivery
 *   (product decision 2026-07-29) — the drawer section stays hidden.
 */
export function getClassroomCapabilities(): ClassroomCapabilities {
  return {
    managerCourseLinks: true,
    assignments: true,
    studentSync: true,
    gradePush: false,
  }
}
